import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 0,6 C 0,5.44772 0.447715,5 1,5 h 13 c 0.5523,0 1,0.44772 1,1 v 12 c 0,0.5523 -0.4477,1 -1,1 H 1 C 0.447715,19 0,18.5523 0,18 Z M 13,17 V 7 H 2 v 10 z M 16,9.58033 c 0,-0.35886 0.1923,-0.6902 0.5039,-0.86824 l 5,-2.85715 C 22.1705,5.474 23,5.95537 23,6.72319 V 17.2768 c 0,0.7679 -0.8295,1.2492 -1.4961,0.8683 l -5,-2.8572 C 16.1923,15.1099 16,14.7785 16,14.4197 Z m 5,5.97327 V 8.44637 l -3,1.71433 v 3.6787 z"
  }));
});
var MultimediaVideocamera = AbstractIcon.withComponent(Icon);
MultimediaVideocamera.displayName = 'MultimediaVideocamera';
export default MultimediaVideocamera;